import {CenterProps} from "../map/types";

type Bounds = [[string, string], [string, string]];

export enum LATAM_COUNTRY_NAMES {
  ARGENTINA = "Argentina",
  CHILE = "Chile",
  COLOMBIA = "Colombia",
  COSTA_RICA = "Costa Rica",
  GUATEMALA = "Guatemala",
  DOMINICAN_REPUBLIC = "Dominican Republic",
  BRAZIL = "Brazil",
  MEXICO = "Mexico",
  CARICOM = "Caricom",
  BAHAMAS = "Bahamas",
  BELIZE = "Belize",
  ST_LUCIA = "St. Lucia",
  TRINIDAD_AND_TOBAGO = "Trinidad and Tobago",
  HAITI = "Haiti",
  LATAM = "LATAM",
  PERU = 'Peru',
  ECUADOR = 'Ecuador',
  PARAGUAY = 'Paraguay',
  BOLIVIA = 'Bolivia',
}

export enum CARICOM_STATES {
  BAHAMAS = "Bahamas",
  BELIZE = "Belize",
  ST_LUCIA = "St. Lucia",
  TRINIDAD_AND_TOBAGO = "Trinidad and Tobago",
  BARBADOS = "Barbados",
  DOMINICA = "Dominica",
  GRENADA = "Grenada",
  GUYANA = "Guyana",
  HAITI = "Haiti",
  JAMAICA = "Jamaica",
  ST_VINCENT_AND_THE_GRENADINES = "St Vincent & The Grenadines",
  SURINAME = "Suriname"
}

export enum ROMANIA_REGION {
  ROMANIA = "Romania",
}

export enum USA_COUNTRY_NAMES {
  USA = "USA",
}

export type COUNTRY_NAME = LATAM_COUNTRY_NAMES | ROMANIA_REGION | USA_COUNTRY_NAMES;

export interface Country {
  country_name: COUNTRY_NAME;
  id: string;
  iso3: string;
  states: State[];
  centro_id: CenterProps;
  country_width: string;
  country_height: string;
  bounds?: Bounds;
  facilities_value: string;
  direct_jobs_value: string;
  indirect_jobs_value: string;
  gdp_contribution_value: string;
  default: boolean;
  region_id: string;
  region_name: string;
}

export interface State {
  state_name: string;
  state_id: string;
  iso3: string | null;
}

export interface CountriesState {
  data: Country[];
  loading: boolean;
  error: string | null;
  mainCountriesForRegions?: Country[];
}
